/**
 * One-shot flag so account_info_submitted can be emitted AFTER the user_id is
 * set, not before the account exists.
 *
 * The signup form previously emitted account_info_submitted on form submit,
 * before the account was created and before LayoutProvider's identify() had run,
 * so the event was always anonymous. Instead, the signup flow sets this flag
 * right before creating the account, and LayoutProvider consumes it inside the
 * identify effect (once the real member user_id is set) to emit the event with
 * the correct user_id. Cleared on signup failure so it never leaks to a later
 * login.
 */
let pending = false;

export const markSignupPending = (value: boolean): void => {
  pending = value;
};

export const consumeSignupPending = (): boolean => {
  const wasPending = pending;
  pending = false;
  return wasPending;
};
